/*
 * Font Awesome v4
 *
 * (note that Font Awesome v5 is no longer open source)
 */

require('@fortawesome/fontawesome-free/js/all');
